// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a4a8b470","34":"58ec6718","114":"864f5573","123":"5eb9ddea","306":"6c08a34e","372":"d59a6f1f","391":"049901de","423":"29d22548","434":"f61930d1","591":"efc74644"}[chunkId] + ".chunk.js";
};